import * as firebase from 'firebase/app';
import 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyAVEsx-4scj214booSxbrytTOTh3Edn9P0",
    authDomain: "samoan-app-25f25.firebaseapp.com",
    databaseURL: "https://samoan-app-25f25.firebaseio.com",
    projectId: "samoan-app-25f25",
    storageBucket: "samoan-app-25f25.appspot.com",
    messagingSenderId: "271007353418",
    appId: "1:271007353418:web:5530fec63a93b5bdf6b4b3",
    measurementId: "G-GRPVW4FEGZ"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();
const auth = firebase.auth();

export {storage, firebase as default, auth };
